import React from "react";
import styled from "styled-components";
import { FaLinkedin } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import Section from "../../components/resumé-page/Section";
import Quote from "../../components/resumé-page/Quote";

const Container = styled(Section)`
    animation-delay: var(--profile-section-delay);

    padding-top: 5rem;

    .row {
        margin-top: 1rem;
    }

    @media only screen and (min-width: 960px) {
        .column {
            flex: 2;
            margin: 10px;
        }

        .row {
            display: flex;
            flex-direction: row;
        }
    }
`;

const Name = styled.h3`
    color: var(--light-font-color);
    align-items: center;
    text-align: center;

    font-size: 2rem;
    padding: 0.5rem 0;
    letter-spacing: 1px;

    @media only screen and (min-width: 960px) {
        text-align: left;
    }
`;

const Role = styled.h4`
    color: var(--mid-font-color);
    text-align: center;

    font-size: 1.15rem;
    padding: 0.5em 0;

    @media only screen and (min-width: 960px) {
        text-align: left;
    }
`;

const PhotoFrame = styled.div`
    display: flex;
    justify-items: center;
    align-items: center;

    @media only screen and (min-width: 1200px) {
    }
`;

const ProfilePhoto = styled.img`
    object-fit: cover;
    border-radius: 50%;
    border: 10px solid var(--light-background-color);
    filter: drop-shadow(0 0 5px var(--light-shadow-color));

    width: 200px;
    height: 200px;
`;

const ContactLinks = styled.p`
    margin-top: 1rem;
`;

const ContactLink = styled.a`
    color: var(--mid-font-color);
    text-decoration: none;
    transition: color 0.5s;

    font-size: 0.6rem;
    margin: 0 10px 0px 10px;

    :hover {
        color: var(--light-font-color);
    }
`;

const EmailIcon = styled(MdEmail)`
    width: 20px;
    height: 20px;
`;

const LinkedInIcon = styled(FaLinkedin)`
    width: 20px;
    height: 20px;
`;

const ProfileSection = () => (
    <Container id="profile-section">
        <div class="row mx-1">
            <PhotoFrame className="m-auto col-xs-4 col-xl-3">
                <ProfilePhoto
                    src="http://www.garrisonweb.net/assets/images/profilepic.png"
                    alt="Odell Garrison Profile Pic"
                    className="img-fluid m-auto"
                />
            </PhotoFrame>
            <div class="col-xs-8 col-xl-9">
                <Role>Software Developer & Engineer</Role>
                <Name>Odell Garrison</Name>
                <p>
                    Detail-oriented application developer with 20+ years success designing innovative and tailored
                    solutions to meet ever changing business requirements within diverse industries. Determined and
                    dedicated individual with strong work ethic. Logical and creative problem-solver with a keen ability
                    to translate complex problems into simple terms and requirements. Team player with a positive and
                    can-do attitude.
                </p>
                <ContactLinks>
                    <ContactLink href="mailto:odell@garrisonweb.net">
                        <EmailIcon />
                    </ContactLink>
                    <ContactLink href="http://www.linkedin.com/in/odell-garrison" target="_blank" rel="noreferrer">
                        <LinkedInIcon />
                    </ContactLink>
                </ContactLinks>
            </div>
        </div>
        <br />
        <br />
        <Quote
            quote="Be who you are and say what you feel, because those who mind don't matter, and those who matter don't mind."
            attributedTo="Bernard M. Baruch"
        />
    </Container>
);

export default ProfileSection;
